import { ChainId } from '@uniswap/sdk-core'
import { FACTORY_ADDRESS } from '@uniswap/v3-sdk'
import {
  QUOTERV2_ADDRESS,
  TICK_LENS_ADDRESS,
  NONFUNGIBLE_POSITION_MANAGER_ADDRESS,
  SWAP_ROUTER_ADDRESS,
  V3_MIGRATOR_ADDRESS,
} from '@hyperswap/addresses'
function constructSameAddressMap(address: string): { [chainId in ChainId]: string } {
  return {
    [ChainId.MAINNET]: address,
    [ChainId.HYPEREVM_TESTNET]: address,
  }
}

export const V3_CORE_FACTORY_ADDRESSES = constructSameAddressMap(FACTORY_ADDRESS)

export const QUOTER_ADDRESSES = constructSameAddressMap(QUOTERV2_ADDRESS)

export const TICK_LENS_ADDRESSES = constructSameAddressMap(TICK_LENS_ADDRESS)

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = constructSameAddressMap(NONFUNGIBLE_POSITION_MANAGER_ADDRESS)

export const SWAP_ROUTER_ADDRESSES = constructSameAddressMap(SWAP_ROUTER_ADDRESS)

export const V3_MIGRATOR_ADDRESSES = constructSameAddressMap(V3_MIGRATOR_ADDRESS)
